import { sel } from "../../academy/selectors";
import { TutorialDefinition } from "../types";

/**
 * Academy lesson: the Footage tab. Started from the lesson page in a new tab;
 * never auto-started. Runs on the officer's own reports: the first step asks
 * them to open one with analyzed footage (footage add-on), then the tour walks
 * the video view. Nothing here attaches or changes anything.
 */
const tour: TutorialDefinition = {
  id: "the-footage-tab",
  version: "1.0.0",
  releasedAt: "2026-10-29T00:00:00.000Z",
  category: "onboarding",
  title: "The Footage tab",
  description: "Read the marker bar, jump to a moment, and attach a still.",
  triggerRoute: /^\/cases(\/.*)?$/,
  startRoute: "/cases",
  lessonId: "the-footage-tab",
  autoStart: false,
  steps: [
    {
      target: sel("caseListItem"),
      title: "Open a report with footage",
      content: "Click a report whose body-cam or surveillance video was analyzed. This needs a footage seat from your department.",
      disableBeacon: true,
      placement: "right",
      advanceOn: { selector: sel("caseListItem"), event: "click" },
      hint: "Open a report to continue",
      spotlightClicks: true,
    },
    {
      target: sel("editorTabTranscription"),
      waitFor: sel("editorTabTranscription"),
      title: "The Footage tab",
      content: "On a case with analyzed footage, the Transcription tab is named Footage. Click it.",
      disableBeacon: true,
      placement: "bottom",
      advanceOn: { selector: sel("editorTabTranscription"), event: "click" },
      hint: "Click the Footage tab",
      spotlightClicks: true,
    },
    {
      target: sel("footageSeekbar"),
      waitFor: sel("footageSeekbar"),
      waitTimeoutMs: 10000,
      title: "The marker bar",
      content: "Each dot is a moment worth a look, colored by kind. Hover one for the still, click it to jump there. Dimmed stretches are where nothing happened.",
      disableBeacon: true,
      placement: "top",
    },
    {
      target: sel("footagePoints"),
      waitFor: sel("footagePoints"),
      title: "What happened",
      content: "The same moments as cards. The one at the playhead lights up, and clicking a card seeks the video.",
      disableBeacon: true,
      placement: "left",
    },
    {
      target: sel("footageKindFilter"),
      waitFor: sel("footageKindFilter"),
      title: "Filter by kind",
      content: "Show only one kind of moment, such as every vehicle or every piece of property handled.",
      disableBeacon: true,
      placement: "left",
    },
    {
      target: sel("footageAttach"),
      waitFor: sel("footageAttach"),
      title: "Attach a still",
      content: "Click a still in this strip to attach it to the exported report. Click it again to remove it. Attach the frame that supports a disputed detail.",
      disableBeacon: true,
      placement: "top",
    },
  ],
};

export default tour;
